var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item",class:{
    'has-children': _vm.hasChildren,
    'has-image': _vm.hasImage
  },on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.hasLink)?_c('router-link',{attrs:{"to":_vm.link}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e(),(_vm.hasChildren || _vm.hasImage || !_vm.hasLink)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }